export default "__VITE_ASSET__BNXHsdUF__"